
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.524 21.347a5.25 5.25 0 01-2.234-.496c-2.632-1.248-3.771-4.407-2.54-7.044l1.383-2.939a5.34 5.34 0 014.809-3.035c.776 0 1.527.167 2.233.496a5.32 5.32 0 012.928 3.719.745.745 0 01-.108.564.744.744 0 01-.625.337.753.753 0 01-.736-.599 3.811 3.811 0 00-2.096-2.663 3.755 3.755 0 00-1.597-.355c-1.47 0-2.824.854-3.451 2.176l-1.381 2.935a3.816 3.816 0 001.821 5.05 3.749 3.749 0 001.597.355c1.47 0 2.825-.854 3.451-2.176a.755.755 0 01.999-.357.75.75 0 01.356.999 5.34 5.34 0 01-4.809 3.033z"}}),_c('path',{attrs:{"d":"M14.556 16.266a5.247 5.247 0 01-2.232-.496 5.314 5.314 0 01-2.743-3.053.745.745 0 01.464-.954.75.75 0 01.954.464 3.803 3.803 0 001.963 2.185 3.741 3.741 0 001.598.355c1.47 0 2.825-.854 3.452-2.176l1.381-2.935a3.816 3.816 0 00-1.821-5.049 3.748 3.748 0 00-1.597-.354c-1.47 0-2.825.854-3.451 2.176a.753.753 0 01-.999.357.75.75 0 01-.357-.999 5.34 5.34 0 014.809-3.033c.776 0 1.528.167 2.233.496 2.632 1.248 3.77 4.407 2.54 7.043l-1.383 2.939a5.342 5.342 0 01-4.81 3.035h-.001z"}})])
          )
        }
      }
    